export default __webpack_public_path__ + "static/media/47k.701001cd.md";